import metafont from "refractor/metafont";
export default metafont;